import React from 'react'
import "../assets/css/divider.css"

const Header = () => (
    <div className="divider"></div>
)

export default Header
